// 加载刷新。
var canLoad=true;
window.refresh= function (topLoad,bottomLoad,target) {
  console.log(target)
  if(!target){
    target=$(window)
  }
  target.on("touchcancel touchend",function(e){
    var scrollTop = $(this).scrollTop();    //滚动条距离顶部的高度
    var scrollHeight = $(document).height();   //当前页面的总高度
    var clientHeight = $(this).height();    //当前可视的页面高度
    if(scrollTop + clientHeight >= scrollHeight){   //距离顶部+当前高度 >=文档总高度 即代表滑动到底部 count++;         //每次滑动count加1

      if(bottomLoad){
        bottomLoad();
      }

    }else if(scrollTop<=0){

      if(topLoad){
        topLoad();
      }

    }

  });

window.rmRefresh= function (){
  target.off("touchcancel touchend");
}

};


//调用
// refresh(fn1,fn2);



// WEBPACK FOOTER //
// ./src/lib/drag-loading.js